import { useEffect, useState } from 'react';

const DEFAULT_DEBOUNCE_TIME = 250;

export const useDebounce = <T extends unknown>(value: T, delay?: number) => {
  const delayTime = delay || DEFAULT_DEBOUNCE_TIME;
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delayTime);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delayTime]);

  return debouncedValue;
};
